import { pick } from './utils';
export const stylableWithSpExperiment = 'specs.responsive-editor.isStylableWithScaleSupport';
export const isUsingStyleProperties = (compStyle, keys) => {
    return keys.every(key => Boolean(compStyle[key]));
};
export const getMigratedStyleProps = ({ compProps, styleProperties, migratedFields, }) => {
    return {
        ...pick(compProps, migratedFields),
        ...pick(styleProperties, migratedFields),
    };
};
const isNumber = (value) => {
    return !Number.isNaN(value);
};
export const parseValueWithUnit = (valueWithUnit, config = {
    fallbackValue: undefined,
}) => {
    const { fallbackValue, shouldRoundValue } = config;
    const numericValue = parseFloat(valueWithUnit);
    const unit = extractUnit(valueWithUnit);
    if (!isNumber(numericValue)) {
        return fallbackValue;
    }
    return {
        value: shouldRoundValue ? Math.round(numericValue) : numericValue,
        unit: unit,
    };
};
export const stringifyValue = (value, unit) => {
    return unit ? `${value}${unit}` : String(value);
};
export const extractUnit = (valueWithUnit) => {
    const DECIMALS_REGEX = /-?\d+(\.\d+)?/;
    const FALLBACK_UNIT = 'px';
    return valueWithUnit.replace(DECIMALS_REGEX, '') || FALLBACK_UNIT;
};
export const ZERO_PIXELS = {
    value: 0,
    unit: 'px',
};
export const addUnitToEveryField = (values, originalValue, spxProps) => {
    const shouldAddSpx = spxProps && originalValue?.toString().endsWith('spx');
    const addUnit = shouldAddSpx
        ? (value) => spxProps.formatCssValueWithSpx(`${value}spx`, spxProps.spx)
        : (value) => `${value}px`;
    return Object.entries(values).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: addUnit(value),
    }), {});
};
//# sourceMappingURL=scaleProportionally.js.map